import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import { create } from '../../services/upload-files.service';
import { exportToExcel } from "../../services/fetch-data.service";

// API Endpoint for exporting GRI report
const EXPORT_GRI_API = 'https://dev.sustainabilitypro.io/api/v1/gri/export_gri_excel?company_id=1';

const GriqnaDetails = () => {
    const userdetails = JSON.parse(localStorage.getItem('userdetails'));
    const [griReportData, setGriReportData] = useState([]);
    const { state } = useLocation();
    const { data, isLoading: isGriLoading } = useFetch('gri/modules/General Disclosure');
    const { data: companyData, isLoading: isCompanyLoading } = useFetch(`gri/company-details?company_id=${userdetails.company_id}`);
    const [isSaving, setIsSaving] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (!isCompanyLoading) {
            const dataToSet = Object.keys(companyData).length > 0 ? companyData.data : data;
            setGriReportData(dataToSet);
        }
    }, [companyData, data, isCompanyLoading]);

    const handleChange = (label, value) => {
        const updatedFormValues = griReportData.map(formData => {
            const updatedQuestions = formData.questions.map(qus => {
                if (qus.type === 'textarea' && qus.question === label) {
                    return {
                        ...qus,
                        answer: value || '',
                    };
                }
                if (qus.sub_questions) {
                    const updatedSubQuestions = qus.sub_questions.map(subQus => {
                        if (subQus.type === 'textarea' && subQus.question === label) {
                            return {
                                ...subQus,
                                answer: value || '',
                            };
                        }
                        return subQus;
                    });
                    return {
                        ...qus,
                        sub_questions: updatedSubQuestions,
                    };
                }
                return qus;
            });
            return {
                ...formData,
                questions: updatedQuestions,
            };
        });

        setGriReportData(updatedFormValues);
    };

    const saveData = (dataToSave) => {
        setIsSaving(true); // Set saving indicator
        create(dataToSave, 'gri/company')
            .then(res => {
                console.log(res);
            })
            .finally(() => {
                setIsSaving(false); // Reset saving indicator
            });
    };

    const handleSubmit = event => {
        event.preventDefault();
        const submitData = {
            company_id: userdetails.company_id,
            module_name: 'General Disclosure',
            data: griReportData,
        };
        setIsSaving(true); // Set saving indicator
        saveData(submitData);
    };

    // Export function for GRI Report
    const exportGriReport = () => {
        exportToExcel(EXPORT_GRI_API, 'griReport');
    };

    const goBack = () => navigate(-1);

    if (isGriLoading || isCompanyLoading || isSaving) {
        return (
            <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                    <h1 className="h2"> <i className="fa-solid fa-spinner fa-spin"></i></h1>
                </div>
            </main>
        );
    }

    return (
        <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <div className="fixed-div">
                    <div className="h2">
                        <Link onClick={goBack}>
                            <i className="fas fa-arrow-left"></i>
                        </Link>
                        GRI Q & A
                    </div>
                    <div className="buttons-right">
                        <button className="btn btn-primary btn-add" onClick={() => saveData({
                            company_id: userdetails.company_id,
                            module_name: 'General Disclosure',
                            data: griReportData,
                        })}>
                            Save 
                        </button>
                        <button className='btn btn-primary btn-add' onClick={exportGriReport}>
                            <i className="fa-solid fa-file-import"></i> Export Report
                        </button>
                    </div>
                </div>
            </div>
            <div className="form-div">
                <form onSubmit={handleSubmit}>
                    <div className="mt-3 griform">
                        {griReportData.map((formData, index) => (
                            <React.Fragment key={index}>
                                <h5><b>{formData.standard}</b></h5>
                                <div className="question-container">
                                    <div style={{ width: '100%' }}>
                                        <h6><b>{formData.disclosure}</b></h6>
                                    </div>
                                    {formData.questions &&
                                        formData.questions.map((qus) => (
                                            <div key={qus.question} className="answer-container">
                                                <div key={qus.question}>
                                                    <label htmlFor={qus.question}><b>{qus.question} </b> </label>
                                                    <br /><br />
                                                    <label htmlFor={qus.title}><b>{qus.title} </b> </label>
                                                    {qus.title &&
                                                        qus.sub_questions &&
                                                        qus.sub_questions.map((ans) => (
                                                            <div className="sub_answer-container" key={ans.question}>
                                                                <div className="answer-container">
                                                                    <div className="ans">
                                                                        <label htmlFor={ans.question}><b>{ans.question} </b> </label>
                                                                        <br /><br />
                                                                        {ans.type === 'textarea' && (
                                                                            <textarea
                                                                                id={ans.question}
                                                                                name={ans.question}
                                                                                value={ans.answer || ''}
                                                                                onChange={(e) => handleChange(ans.question, e.target.value)}
                                                                                rows="3" cols="40"
                                                                            />
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    {qus.type === 'textarea' && (
                                                        <textarea
                                                            id={qus.question}
                                                            name={qus.question}
                                                            value={qus.answer || ''}
                                                            onChange={(e) => handleChange(qus.question, e.target.value)}
                                                            rows="3" cols="65"
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                </div>
                            </React.Fragment>
                        ))}
                    </div>
                    <div className="mt-3 mb-3">
                        <button className="btn btn-primary btn-add" type="submit">
                            Submit
                        </button>
                    </div>
                </form>
            </div>
        </main>
    );
};

export default GriqnaDetails;
